import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import { create } from '@thoughtspot/logger';
const logger = create('Pendo');
let pendoOpts = null;
const pendoKey = '8309b5a7-7990-4386-6a3f-cb0c0de6ef4a';
const LOCAL_CLUSTER_ID = 'local';
let LOADED_SCRIPTS_NUMBER = 0;
export function isDevCluster() {
    return pendoOpts && pendoOpts.getClusterId() === LOCAL_CLUSTER_ID;
}
export function getPendoVisitorConfig(version) {
    const currentDateISOString = new Date().toISOString();
    const visitorId = pendoOpts.getHostConfig()
        ? `${pendoOpts.getHostConfig().hostUserGuid}|${pendoOpts.getHostConfig().hostClusterId}`
        : `${pendoOpts.getUserGuid()}|${pendoOpts.getClusterId()}`;
    const clusterId = pendoOpts.getHostConfig()?.hostClusterId || pendoOpts.getClusterId();
    const config = {
        id: visitorId,
        isAdminUser: pendoOpts.hasAdminPrivileges(),
        firstLoginDate: new Date(pendoOpts.getFirstLoginDate()).toISOString(),
        embedUser: pendoOpts.isEmbedded(),
        userLocale: pendoOpts.getPreferredLocale(),
        lastLogin: currentDateISOString,
        releaseVersion: version,
        hasEmail: !!pendoOpts.getUserEmail(),
        userPersona: pendoOpts.getUserPersona(),
        acquisitionChannel: pendoOpts.getUserActivationMode(),
        hasSearchAssist: pendoOpts.isAAQEnabled(),
        hasHomePageV2: pendoOpts.isHomeV2Enabled(),
        isLiveboardEnabled: pendoOpts.getIsLiveboardEnabled(),
        documentationLink: pendoOpts.getDocumentationLink(),
        teamId: pendoOpts.getTeamId(),
        isInIframe: pendoOpts.isInIframe(),
        orgId: pendoOpts.getOrgId(),
        clusterId,
        isGlobalNavEnabled: pendoOpts.isGlobalNavEnabled(),
        isRolesEnabled: pendoOpts.isRolesEnabled(),
        userType: pendoOpts.userType(),
    };
    return config;
}
export function getPendoAccountConfig() {
    const config = {
        id: pendoOpts.getHostConfig()?.hostClusterId ||
            pendoOpts.getClusterId(),
        name: pendoOpts.getHostConfig()?.hostClusterName ||
            pendoOpts.getClusterName(),
    };
    return config;
}
export function initializePendo() {
    const releaseVersion = pendoOpts.getReleaseVersion();
    window.pendo.initialize({
        apiKey: pendoKey,
        visitor: getPendoVisitorConfig(releaseVersion),
        account: getPendoAccountConfig(),
        additionalApiKeys: [pendoOpts.additionalPendoKey],
    });
}
function shouldTriggerInitializePendo() {
    LOADED_SCRIPTS_NUMBER += 1;
    if (LOADED_SCRIPTS_NUMBER === 4) {
        initializePendo();
    }
}
function onPendoLoadError(err) {
    logger.warn('Unable to load Pendo', err);
}
export function isPendoAllowed(isPrintPage = false, isEmbedded = false, isAllowedInLDExceptionList = false, isNotAProductionCluster = false) {
    if (isPrintPage || envFlags.getValue(FLAGS.e2eTest.name)) {
        return false;
    }
    if (isAllowedInLDExceptionList) {
        return true;
    }
    return !isNotAProductionCluster && !isEmbedded;
}
export async function insertPendoScript(opts) {
    pendoOpts = opts;
    if (!opts.isAllowedInLDExceptionList &&
        (opts?.isNotAProductionCluster || !opts.isPendoEnabled())) {
        return Promise.resolve();
    }
    return setTimeout(() => {
        let w;
        let x;
        let y;
        let z;
        let didReportPendoError = false;
        const o = (window.pendo = window.pendo || {});
        o.q = [];
        const v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
        for (w = 0, x = v.length; w < x; ++w) {
            const m = v[w];
            const func = function () {
                o.q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
            };
            o[m] = o[m] || func();
            y = document.createElement('script');
            y.defer = !0;
            y.src = `https://cdn.pendo.io/agent/static/${pendoKey}/pendo.js`;
            y.onload = () => {
                shouldTriggerInitializePendo();
            };
            y.onerror = err => {
                if (!didReportPendoError) {
                    didReportPendoError = true;
                    onPendoLoadError(err);
                }
            };
            z = document.getElementsByTagName('script')[0];
            z.parentNode.insertBefore(y, z);
        }
    }, 1000);
}
//# sourceMappingURL=pendo.js.map